var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import Button from './Button';

import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';

var messages = defineMessages({
  login: {
    id: 'button.action.login',
    defaultMessage: 'Log in'
  },
  logout: {
    id: 'button.action.logout',
    defaultMessage: 'Log out'
  },
  change: {
    id: 'button.action.change',
    defaultMessage: 'Change'
  },
  finder: {
    id: 'button.action.finder',
    defaultMessage: 'Finder'
  },
  upload: {
    id: 'button.action.upload',
    defaultMessage: 'Upload'
  },
  save: {
    id: 'button.action.save',
    defaultMessage: 'Save'
  },
  saving: {
    id: 'button.action.saving',
    defaultMessage: 'Saving ...'
  },
  saveAs: {
    id: 'button.action.saveAs',
    defaultMessage: 'Save as ...'
  },
  saveAsDraft: {
    id: 'button.action.saveAsDraft',
    defaultMessage: 'Save as draft'
  },
  saveAndPublish: {
    id: 'button.action.saveAndPublish',
    defaultMessage: 'Save and publish'
  },
  edit: {
    id: 'button.action.edit',
    defaultMessage: 'Edit'
  },
  view: {
    id: 'button.action.view',
    defaultMessage: 'View'
  },
  refs: {
    id: 'button.action.refs',
    defaultMessage: 'Links'
  },
  delete: {
    id: 'button.action.delete',
    defaultMessage: 'Delete'
  },
  restore: {
    id: 'button.action.restore',
    defaultMessage: 'Restore'
  },
  erase: {
    id: 'button.action.erase',
    defaultMessage: 'Erase'
  },
  star: {
    id: 'button.action.star',
    defaultMessage: 'Star'
  },
  unstar: {
    id: 'button.action.unstar',
    defaultMessage: 'Starred'
  },
  add: {
    id: 'button.action.add',
    defaultMessage: 'Add'
  },
  remove: {
    id: 'button.action.remove',
    defaultMessage: 'Remove'
  },
  select: {
    id: 'button.action.select',
    defaultMessage: 'Select'
  },
  unselect: {
    id: 'button.action.unselect',
    defaultMessage: 'Unselect'
  }
});

var ButtonIntl = function (_React$Component) {
  _inherits(ButtonIntl, _React$Component);

  function ButtonIntl() {
    _classCallCheck(this, ButtonIntl);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  ButtonIntl.prototype.render = function render() {
    var intlLabel = this.props.intlLabel;


    var label = intlLabel;

    if (messages[intlLabel]) {
      label = this.props.intl.formatMessage(messages[intlLabel]);
    }

    return React.createElement(Button, _extends({}, this.props, { label: label, title: false, intlLabel: false }));
  };

  return ButtonIntl;
}(React.Component);

export default injectIntl(ButtonIntl);